import { useEffect } from "react";

const BASE_SIZES = {
  // Legacy Sizes (Preserved)
  "--font-size-xs": 13,
  "--font-size-sm": 14,
  "--font-size-md": 16,
  "--font-size-lg": 18,
  "--font-size-xl": 20,
  "--font-size-xxl": 22,

  // Styling Guide Tokens
  "--font-size-heading": 28,
  "--font-size-subheading": 22,
  "--font-size-body": 18,
  "--font-size-base": 18,
  "--font-size-caption": 14,
  "--font-size-small": 13,

  // Icons
  "--icon-size-xs": 12,
  "--icon-size-sm": 14,
  "--icon-size-md": 16,
  "--icon-size-lg": 20,
  "--icon-size-xl": 24,
  "--icon-size-xxl": 32,
  "--icon-size-36": 36,
  "--icon-size-40": 40,
  "--icon-size-48": 48,
  "--icon-size-56": 56,
  "--icon-size-64": 64,

  // Spacing (scaled with font)
  "--spacing-1": 4,
  "--spacing-2": 8,
  "--spacing-3": 12,
  "--spacing-4": 16,
  "--spacing-5": 20,
  "--spacing-6": 24,
};

const useFontScale = () => {
  useEffect(() => {
    const handleMessage = (event) => {
      let data = event.data;
      if (typeof data === "string") {
        try {
          data = JSON.parse(data);
        } catch (e) {
          // Ignore parse errors
          return;
        }
      }

      if (data?.type === "SET_FONT_SCALE") {
        const scale = parseFloat(data.payload);
        if (!isNaN(scale)) {
          Object.entries(BASE_SIZES).forEach(([key, baseSize]) => {
            const newSize = `${baseSize * scale}px`;
            document.documentElement.style.setProperty(key, newSize);
          });
        }
      }
    };

    // Add event listeners for both window and document (to support various WebView implementations)
    window.addEventListener("message", handleMessage);
    document.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
      document.removeEventListener("message", handleMessage);
    };
  }, []);
};

export default useFontScale;
